import { baseClient } from '../common';
import { ItemModel } from './item.model';
import { UpdateItemStatusModel } from './update-item-status.model';

export const itemClient = {
  list: (shopId: string): Promise<ItemModel[]> => {
    return baseClient.get<ItemModel[]>(`/api/shops/${shopId}/items`);
  },

  updateStatus: (
    key: string,
    model: UpdateItemStatusModel,
  ): Promise<ItemModel> => {
    return baseClient.body<UpdateItemStatusModel, ItemModel>({
      body: model,
      method: 'PUT',
      url: `/api/items/${key}`,
    });
  },
};
